var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPresentationAccessLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15.625C67.9 15.625 82.6312 29.3813 84.2156 46.875H96.7156C95.0969 22.4844 74.7938 3.125 50 3.125C25.2063 3.125 4.90312 22.4844 3.28437 46.875H15.7844C17.3687 29.3813 32.1 15.625 50 15.625Z",
    fill: "#FC3165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84.375C32.1 84.375 17.3687 70.6187 15.7844 53.125H3.28437C4.90312 77.5156 25.2063 96.875 50 96.875C74.7938 96.875 95.0969 77.5156 96.7156 53.125H84.2156C82.6312 70.6187 67.9 84.375 50 84.375Z",
    fill: "#FC3165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 39.0625H45.3125V73.4375H54.6875V39.0625Z",
    fill: "#000044"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 26.5625H45.3125V35.9375H54.6875V26.5625Z",
    fill: "#000044"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPresentationAccessLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-presentation-access-light.e4a7ed5b6deb9e0432cae97ee7fccba3.svg";